import React, { memo, useCallback, useState } from 'react';
import { Dropdown } from '@nexus/lib-react/dist/core/Dropdown/Dropdown';
import { DropdownStatus } from '@nexus/lib-react/dist/core/Dropdown/DropdownStatus';
import S from './style/Dac7Dropdown';
import Input from '../../../../../commons/components/primitives/Input';
import { Dac7FormInputName } from '../types/Dac7FormInputName';

interface Props {
  label: string;
  name: Dac7FormInputName;
  sourceItems: Array<{ id: string; label: string }>;
  initialSelectedIds: Array<string | number>;
  onChange?: (ids: Array<string | number>) => void;
  required?: boolean;
  requiredMessage?: string;
  selectPrompt?: string;
  placeholder?: string;
  filterOptions?: boolean;
  multiple?: boolean;
  disabled?: boolean;
}

const Dac7Dropdown = ({
  label,
  name,
  sourceItems,
  initialSelectedIds = [],
  onChange,
  required = false,
  requiredMessage,
  placeholder,
  selectPrompt,
  filterOptions = true,
  multiple = false,
  disabled = false,
}: Props) => {
  const [selectedIds, setSelectedIds] = useState(initialSelectedIds);
  const [touched, setTouched] = useState(false);

  const selectedIdChanged = useCallback(
    (_selectedIds: Array<string | number>) => {
      setSelectedIds(_selectedIds);
      setTouched(true);
      if (onChange) onChange(_selectedIds);
    },
    [onChange],
  );

  const getDropdownStatus = () =>
    sourceItems.some(({ id }) => selectedIds.includes(id))
      ? DropdownStatus.SUCCESS
      : DropdownStatus.ERROR;
  const dropDownStatus: DropdownStatus = touched ? getDropdownStatus() : null;

  return (
    <S.Dac7DropdownContainer className="dac7_dropdown">
      <aside>
        <Input
          label={label}
          required={required}
          dirty={touched}
          name={name}
          value={selectedIds?.toString()}
          requiredMessage={requiredMessage}
          disabled={disabled}
        />
      </aside>
      <Dropdown
        sourceItems={selectPrompt ? [{ id: '', label: selectPrompt }, ...sourceItems] : sourceItems}
        selectedIds={selectedIds}
        variant="dark"
        mt={4}
        onSelectedIdsChange={selectedIdChanged}
        status={dropDownStatus}
        className="dac7-dropdown"
        multiselectEnabled={multiple}
        disabled={disabled}
        placeholder={placeholder}
        filterOptions={filterOptions}
      />
    </S.Dac7DropdownContainer>
  );
};

export default memo(Dac7Dropdown);
